class QuickViewDrawer extends MenuDrawer {
  constructor() {
    super();

    this.setClasses({
      open: 'quick-view--open',
      opening: 'quick-view--opening',
      closing: 'quick-view--closing'
    });

    this.addEventListener('close', () => {
      const drawerContent = this.querySelector('.quick-view__content');
      drawerContent.innerHTML = '';
      drawerContent.classList.remove('hide-cover');

      document.dispatchEvent(new CustomEvent('quickview:close'));
    });
  }
}
customElements.define('quick-view-drawer', QuickViewDrawer);

class QuickViewButton extends MenuDrawer {
  constructor() {
    super();

    this.addEventListener('click', () => {
      const wrapper = this.closest('.card-wrapper');
      const drawer = wrapper.querySelector('quick-view-drawer');
      if (drawer) {
        drawer.querySelector('summary').click();

        document.dispatchEvent(new CustomEvent('quickview:open', {
          detail: {
            productUrl: this.dataset.productUrl
          }
        }));
      }
      else if (this.dataset.productUrl) {
        window.location.href = this.dataset.productUrl;
      }
    });
  }
}
customElements.define('quick-view-button', QuickViewButton);

class QuickView extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      const linkedProduct = event.target.closest('[data-linked-product-url]');
      if (!linkedProduct || !this.contains(linkedProduct)) return;

      event.preventDefault();
      const productUrl = linkedProduct.dataset.linkedProductUrl || linkedProduct.getAttribute('href');
      if (productUrl) {
        this.loadProduct(productUrl);
      }
    });
  }

  connectedCallback() {
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.disconnect();
    this.loadProduct(this.dataset.productUrl);
  }

  loadProduct(productUrl) {
    if (!productUrl || this.dataset.loadingLinkedProduct === 'true') return;

    const selector = '.quick-view__content';
    const drawerContent = this.querySelector(selector);
    if (!drawerContent) return;

    const cleanProductUrl = productUrl.split('?')[0];
    const sectionUrl = `${cleanProductUrl}?view=modal`;

    this.dataset.loadingLinkedProduct = 'true';
    drawerContent.classList.remove('hide-cover');
    drawerContent.setAttribute('aria-busy', 'true');

    fetch(sectionUrl)
      .then(response => {
        if (!response.ok) throw new Error(`Quick View HTTP ${response.status}`);
        return response.text();
      })
      .then(responseText => {
        const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
        const productElement = responseHTML.querySelector(selector);
        if (!productElement) throw new Error('Quick View content not found');

        this.setInnerHTML(drawerContent, productElement.innerHTML);
        this.dataset.productUrl = cleanProductUrl;

        if (window.Shopify && Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }

        requestAnimationFrame(() => {
          drawerContent.classList.add('hide-cover');
          drawerContent.removeAttribute('aria-busy');

          document.dispatchEvent(new CustomEvent('quickview:loaded', {
            detail: {
              productUrl: cleanProductUrl
            }
          }));
        });
      })
      .catch(e => {
        console.error(e);
        window.location.href = cleanProductUrl;
      })
      .finally(() => {
        delete this.dataset.loadingLinkedProduct;
      });
  }

  setInnerHTML(element, html) {
    element.innerHTML = html;

    // Reinjects script tags because scripts inserted through innerHTML do not execute automatically.
    element.querySelectorAll('script').forEach(oldScriptTag => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach(attribute => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}
customElements.define('quick-view', QuickView);
